// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"155":"df87fc80a4edc884","2888":"ac7db97c4dede9cc"}[chunkId] + ".css";
};